const NAVIGATION_BAR_DATA = [
  {
    id: 1,
    title: "Home",
    href: "/",
  },
  {
    id: 2,
    title: "About us",
    href: "/about",
  },
  {
    id: 3,
    title: "Service",
    href: "/service",
  },
  {
    id: 4,
    title: "Contact",
    href: "/contact",
  },
];

export default NAVIGATION_BAR_DATA;
